// extracted by mini-css-extract-plugin
module.exports = {"container_top":"topgainers_container_top__2dgDR","container_elem":"topgainers_container_elem__3XK-j"};